// boot-context.ts — how this document booted (SC-54713). "page": Dice's own index.html (the standalone FUN-only host, the
// dev server). "shell": rgs-core-api-gw's /play/dice document (option C, the REAL-capable production path), which injects
// src/shell-entry.ts from Dice's own site. shell-entry.ts marks it BEFORE it takes the launch, so the launch decision
// (launch.ts) already sees it: in the shell a bare URL is never a launch, whatever the page build's bare-load policy.
let bootedByShell = false;

export function markShellBoot(): void {
  bootedByShell = true;
}

export function isShellBoot(): boolean {
  return bootedByShell;
}
